import { render, staticRenderFns } from "./EditarFabricanteLote.vue?vue&type=template&id=2579c9b9&"
import script from "./EditarFabricanteLote.vue?vue&type=script&lang=js&"
export * from "./EditarFabricanteLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports